import { Configuration, PopupRequest } from '@azure/msal-browser';
import { configService, AppConfiguration } from './configService';

let msalConfig: Configuration | null = null;
let loginRequest: PopupRequest | null = null;

export const createMsalConfig = (authConfig: AppConfiguration['auth']): Configuration => {
  return {
    auth: {
      clientId: authConfig.clientId,
      authority: authConfig.authority,
      redirectUri: authConfig.redirectUri,
      postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case 0:
              console.error(message);
              return;
            case 1:
              console.warn(message);
              return;
            case 2:
              console.info(message);
              return;
            case 3:
              console.debug(message);
              return;
          }
        },
      },
    },
  };
};

export const createLoginRequest = (scopes: string[]): PopupRequest => {
  return {
    scopes,
    prompt: 'login', // Force fresh login to get v2.0 tokens
  };
};

export const initializeMsalConfig = async (): Promise<{ msalConfig: Configuration, loginRequest: PopupRequest }> => {
  if (msalConfig && loginRequest) {
    return { msalConfig, loginRequest };
  }

  const config = await configService.getConfig();
  
  msalConfig = createMsalConfig(config.auth);
  loginRequest = createLoginRequest(config.auth.scopes);

  return { msalConfig, loginRequest };
};

// Export loginRequest for components that need it
export { loginRequest };

// Legacy export for backward compatibility - will be removed
export default async (): Promise<Configuration> => {
  const { msalConfig } = await initializeMsalConfig();
  return msalConfig;
};